<template>
	<v-card class="rounded-xl">
		<v-card-title dark class="d-flex justify-end align-end flex-shrink-1 primary">
			<div class="d-flex">
				<v-avatar size="32" color="white" class="mr-4">
					<v-icon color="dark" size="24">mdi-car</v-icon>
				</v-avatar>
				<h1 class="text-h4 font-weight-bold white--text mb-1">
					Vehículo
				</h1>
			</div>
			<v-spacer></v-spacer>
			<div class="d-flex justify-end align-end flex-shrink-1" style="gap:8px;">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="blue-grey" @click="saveVeh()" v-bind="attrs" v-on="on"
							class="white--text darken-2">
							Guardar
							<v-icon right>mdi-content-save</v-icon>
						</v-btn>
					</template>
					<span>Guardar</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" fab small color="white" @click="close()" class="primary--text">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</template>
					<span>Cerrar</span>
				</v-tooltip>
			</div>
		</v-card-title>

		<!-- <v-divider></v-divider> -->
		<v-card flat class="pa-2 rounded-b-xl">
			<v-container fluid class="pa-0">
				<v-card class="mb-4 elevation-1 rounded-lg">
					<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold">
						<v-icon left class="mr-2" color="primary">mdi-card-text</v-icon>
						Datos Generales
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-container fluid grid-list-xs class="ma-0 pa-0">
							<v-row dense>
								<v-col cols="12" sm="6" md="4" lg="2" class="" v-if="typeArea == 2">
									<s-select-definition add :def="1198" v-model="item.TypeVehicleBrand"
										label="Tipo Veh." />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-select-definition add :def="1131" v-model="item.TypeVehicle" label="Tipo" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-text v-model="item.VehPlate" label="Placa" @input="validateInput" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-select-definition add :def="1133" v-model="item.TypeColor" label="Color" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-text v-model="item.VehMileage" label="Kilometraje" type="tel" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="" v-if="$fun.isAdmin()">
									<s-select-definition :def="1136" v-model="item.VehStatus" label="Estado" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-select-definition add :def="1115" v-model="item.TypeBrand" label="Marca" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-select-definition add :def="1132" v-model="item.TypeModel" label="Modelo" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-text v-model="item.VehMotor" label="Motor" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-text v-model="item.VehSerie" label="Serie" />
								</v-col>
								<v-col cols="12" sm="6" md="4" lg="2" class="">
									<s-text v-model="item.RegistrationConstancy" label="Constancia de Inscripción N°" />
								</v-col>
								<v-col cols="6" sm="4" md="3" lg="1" class="">
									<s-text label="Año Fabr" type="tel" number v-model="item.VehFabricationYear" />
								</v-col>
								<v-col cols="6" sm="4" md="3" lg="1" class="">
									<s-text v-model="item.VehSeatCapacity" type="tel" number label="Asientos" />
								</v-col>
								<v-col cols="12" sm="12" md="8" lg="6" xl="5" class="">
									<s-select-carriers autocomplete v-model="item.VehRuc" label="Transportista"
										@change="changecarrier" return-object @returnObject="changecarrier"
										:add="true" />
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>

				<v-row dense>
					<v-col cols="12" sm="6" md="6" lg="3" xl="3">
						<v-card class="mb-4 elevation-1 rounded-lg h-100">
							<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold d-flex align-center">
								<v-icon left class="mr-2" color="primary">mdi-shield-check</v-icon>
								SOAT
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container grid-list-xs class="ma-0 pa-0">
									<v-row>
										<v-col cols="12" sm="12" md="12" lg="12" class="s-col-form text-end">
											<v-btn small color="primary" @click="verifySoat()"
												:disabled="isSearchedSoat">
												<v-icon left>mdi-shield-check</v-icon>
												Consultar SOAT
											</v-btn>
										</v-col>
										<v-col cols="12" sm="12" md="12" lg="12" class="s-col-form">
											<s-select-definition add :def="1134" v-model="item.TypeEnsuredr"
												label="Aseguradora" clearable />
										</v-col>
										<v-col cols="12" sm="6" md="6" lg="6" class="s-col-form">
											<s-date label="Inicio" v-model="item.VehEnsuredInit" nullable />
										</v-col>
										<v-col cols="12" sm="6" md="6" lg="6" class="s-col-form">
											<s-date label="Fin" v-model="item.VehEnsuredEnd" nullable />
										</v-col>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-text v-model="item.VehEnsuredCost" decimal type="tel"
												label="Precio S/" />
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" sm="6" md="6" lg="3" xl="3">
						<v-card class="mb-4 elevation-1 rounded-lg h-100">
							<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold d-flex align-center">
								<v-icon left class="mr-2" color="primary">mdi-car-wrench</v-icon>
								Revisión Técnica
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container grid-list-xs class="ma-0 pa-0">
									<v-row>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-date label="Inicio" v-model="item.VehTechnicalReviewInit" nullable />
										</v-col>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-date label="Fin" v-model="item.VehTechnicalReviewEnd" nullable />
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" sm="6" md="6" lg="3" xl="3">
						<v-card class="mb-4 elevation-1 rounded-lg h-100">
							<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold d-flex align-center">
								<v-icon left class="mr-2" color="primary">mdi-file-certificate</v-icon>
								Póliza
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container grid-list-xs class="ma-0 pa-0">
									<v-row>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-text v-model="item.VehPolicy" label="N° Poliza" />
										</v-col>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-date label="Inicio" v-model="item.VehPolicyInit" nullable />
										</v-col>
										<v-col cols="12" sm="12" md="6" lg="12" class="s-col-form">
											<s-date label="Fin" v-model="item.VehPolicyEnd" nullable />
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" sm="6" md="6" lg="3" xl="3">
						<v-card class="mb-4 elevation-1 rounded-lg h-100">
							<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold d-flex align-center">
								<v-icon left class="mr-2" color="primary">mdi-map-marker</v-icon>
								GPS
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-container grid-list-xs class="ma-0 pa-0">
									<v-row>
										<v-col cols="12" sm="12" md="12" lg="12" class="s-col-form">
											<s-select-definition add :def="1135" v-model="item.TypeGpsProvider"
												label="Proveedor" clearable />
										</v-col>
										<v-col cols="12" sm="12" md="12" lg="12" class="s-col-form">
											<s-text v-model="item.VehGpsNumber" label="Número" />
										</v-col>
										<v-col cols="12" sm="6" md="6" lg="6" class="s-col-form">
											<s-date label="Inicio" v-model="item.VehGpsInit" nullable />
										</v-col>
										<v-col cols="12" sm="6" md="6" lg="6" class="s-col-form">
											<s-date label="Fin" v-model="item.VehGpsEnd" nullable />
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>

				<v-card class="mb-2 elevation-1 rounded-lg" v-if="itemsSoat.length > 0">
					<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold">
						<v-icon left class="mr-2" color="primary">mdi-truck</v-icon>
						Se encontraron {{ itemsSoat.length }} documentos de SOAT
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-container grid-list-xs class="ma-0 pa-0 pb-5">
							<v-data-table mobile-breakpoint="0" item-key="CodigoUnicoPoliza" dense :items="itemsSoat"
								v-model="selectedSoat" height="272" :headers="soatHeaders" class="elevation-0"
								:items-per-page="-1" @dblclick:row="doubleClick">

								<template v-slot:item.Estado="{ item }">
									<v-chip x-small outlined class="white--text px-1"
										:color="item.Estado == 'VIGENTE' ? 'success' : 'error'">
										{{ item.Estado }}
									</v-chip>
								</template>
								<template v-slot:item.FechaInicio="{ item }">
									<div class="pa-0 text-center">
										{{ $fun.formatDateView(item.FechaInicio) }}
									</div>
								</template>
								<template v-slot:item.FechaFin="{ item }">
									<div class="pa-0 text-center">
										{{ $fun.formatDateView(item.FechaFin) }}
									</div>
								</template>
								<template v-slot:item.FechaCreacion="{ item }">
									<div class="pa-0 text-center">
										{{ $fun.formatDateView(item.FechaCreacion) }}
									</div>
								</template>
							</v-data-table>
						</v-container>
					</v-card-text>
				</v-card>

				<!-- <v-card class="mb-2 elevation-1 rounded-lg" v-if="typeArea == 2">
					<v-card-title class="subtitle-1 pa-2 primary--text font-weight-bold">
						<v-icon left class="mr-2" color="primary">mdi-truck</v-icon>
						Datos de Transportista
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-container grid-list-xs class="ma-0 pa-0 pb-5">
							<v-row>
								<v-col cols="12" sm="12" md="8" lg="6" xl="5" class="s-col-form">
									<s-select-carriers autocomplete v-model="item.VehRuc" label="Transportista"
										@change="changecarrier" return-object @returnObject="changecarrier"
										:add="true" />
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card> -->



			</v-container>
		</v-card>
	</v-card>
</template>

<script>
import _sVehicle from "@/services/Management/VehicleService";
import _SpcCarrierService from "@/services/SupplyChain/Transport/SpcCarrierService.js";
import SSelectCarriers from "../../../components/Utils/SSelectCarriers.vue";

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrAfter)

export default {
	props: {
		value: {
			required: false,
			default: -1,
		},
		areID: {
			default: 0,
			type: Number
		},
		typeArea: { type: Number, default: 1 }
	},
	components: { SSelectCarriers },
	data() {
		return {
			isSearchedSoat: false,
			selectedSoat: [],
			soatHeaders: [
				{ text: 'Fecha Inicio', value: 'FechaInicio' },
				{ text: 'Vencimiento', value: 'FechaFin' },
				{ text: 'Tipo Certificado', value: 'TipoCertificado' },
				{ text: 'Aseguradora', value: 'NombreCompania' },
				{ text: 'Estado', value: 'Estado' },
				{ text: 'N° Poliza', value: 'NumeroPoliza' },
				{ text: 'Uso del Vehículo', value: 'NombreUsoVehiculo' },
				{ text: 'Tipo Vehículo', value: 'NombreClaseVehiculo' },
				{ text: 'Registrado', value: 'FechaCreacion' },
			],
			itemsSoat: [],
			verificationDay: "",
			item: this.defaultVehicle(),
			itemsCarriers: [],
		};
	},
	created() {
		this.verificationDay = this.moment().add(15, "days").format(this.$const.FormatDateMoment);
		this.loadcarriers();
		this.initialize();
	},
	watch: {
		value() {
			this.initialize();
		},
	},
	computed: {},
	methods: {
		initialize() {
			this.isSearchedSoat = false;
			this.itemsSoat = []
			if (this.value > 0) {
				_sVehicle.get({ VehID: this.value }, this.$fun.getUserID()).then((r) => {
					this.item = Array.isArray(r.data) ? (r.data[0] || this.defaultVehicle()) : (r.data || this.defaultVehicle());
					console.log('Initialize', JSON.parse(JSON.stringify(this.item)))
					this.returnObject();
				});
			} else this.item = this.defaultVehicle();
		},
		defaultVehicle() {
			return {
				VehID: -1,
				AreID: 0,
				TypeArea: 1,
				TypeVehicle: 1,
				VehPlate: "",
				VehMotor: "",
				VehSerie: "",
				TypeBrand: 0,
				TypeModel: 0,
				TypeColor: 0,
				VehFabricationYear: 0,
				VehSeatCapacity: 0,
				TypeEnsuredr: null,
				VehEnsuredInit: null,
				VehEnsuredEnd: null,
				VehEnsuredCost: 0.0,
				VehPolicy: null,
				VehPolicyInit: null,
				VehPolicyEnd: null,
				VehTechnicalReviewInit: null,
				VehTechnicalReviewEnd: null,
				TypeGpsProvider: null,
				VehGpsNumber: null,
				VehGpsInit: null,
				VehGpsEnd: null,
				VehMileage: 0,
				VehStatus: 1, //Pendiente Aprobación
				SecStatus: 1,
				SpcID: 0,
				Documents: [],
			};
		},
		returnObject() {
			this.$emit("returnObject", this.item);
		},
		close() {
			this.$emit("close");
			this.$emit("input", -1);
			this.item = this.defaultVehicle();
		},
		colorEnsuredr(item) {
			let color = "grey";
			if (item.VehEnsuredEnd != "" && item.VehEnsuredEnd != null) {
				if (this.verificationDay >= item.VehEnsuredEnd) color = "warning";
				else color = "success";
			}

			return color;
		},
		colorPolicy(item) {
			let color = "grey";
			if (item.VehPolicyEnd != "" && item.VehPolicyEnd != null) {
				if (this.verificationDay >= item.VehPolicyEnd) color = "warning";
				else color = "success";
			}

			return color;
		},
		colorTechnicalReview(item) {
			let color = "grey";
			if (item.VehTechnicalReviewEnd != "" && item.VehTechnicalReviewEnd != null) {
				if (this.verificationDay >= item.VehTechnicalReviewEnd) color = "warning";
				else color = "success";
			}

			return color;
		},
		colorGPS(item) {
			let color = "grey";
			if (item.VehGpsEnd != "" && item.VehGpsEnd != null) {
				if (this.verificationDay >= item.VehGpsEnd) color = "warning";
				else color = "success";
			}

			return color;
		},
		validatedVeh(item) {
			// console.log(item)
			if (item.VehPlate == undefined || item.VehPlate.length <= 0) {
				this.$fun.alert("Ingrese Placa de vehículo", "warning");
				return false;
			}
			if (item.VehFabricationYear == undefined || item.VehFabricationYear <= 0) {
				this.$fun.alert("Ingrese Año de Fabricación", "warning");
				return false;
			}
			if (item.VehSeatCapacity == undefined || item.VehSeatCapacity <= 0) {
				this.$fun.alert("Ingrese Cantidad de asientos", "warning");
				return false;
			}
			if (item.SpcID == undefined || item.SpcID == null || item.SpcID == '') {
				this.$fun.alert("Seleccionar transportista", "warning");
				return false;
			}
			if (item.TypeEnsuredr == undefined || item.TypeEnsuredr <= 0) {
				this.$fun.alert("Seleccionar asegurador del SOAT", "warning");
				return false;
			}
			if (item.VehEnsuredInit == undefined || item.VehEnsuredInit == null) {
				this.$fun.alert("Seleccionar fecha de inicio del SOAT", "warning");
				return false;
			}
			if (item.VehEnsuredEnd == undefined || item.VehEnsuredEnd == null) {
				this.$fun.alert("Ingresar fecha de vencimiento del SOAT", "warning");
				return false;
			}

			const _startDate = dayjs(item.VehEnsuredInit, 'DD-MM-YYYY')
			const _expireDate = dayjs(item.VehEnsuredEnd, 'DD-MM-YYYY')

			if (!_expireDate.isAfter(_startDate)) {
				this.$fun.alert("Verifique fecha de vencimiento del SOAT", "warning");
				return false;
			}

			if (item.VehTechnicalReviewInit != "") {
				if (item.VehTechnicalReviewEnd == null || item.VehTechnicalReviewEnd == "") {
					this.$fun.alert("Verifique rango de fecha de la Revisión Vehicular", "warning");
					return false;
				}
				if (!this.$fun.isValidRangeDate(item.VehTechnicalReviewInit, item.VehTechnicalReviewEnd)) {
					this.$fun.alert("Verifique rango de fecha de la Revisión Vehicular", "warning");
					return false;
				}
			}

			if (item.VehPolicy != null) {
				if (item.VehPolicyInit == "") {
					this.$fun.alert("Seleccionar fecha de inicio de la POLIZA", "warning");
					return false;
				}
				if (item.VehPolicyEnd == "") {
					this.$fun.alert("Seleccionar fecha fín de la POLIZA", "warning");
					return false;
				}
				if (!this.$fun.isValidRangeDate(item.VehPolicyInit, item.VehPolicyEnd)) {
					this.$fun.alert("Verifique rango de fecha de la POLIZA", "warning");
					return false;
				}
			}

			if (item.TypeGpsProvider != null) {
				if (item.VehGpsInit == "") {
					this.$fun.alert("Seleccionar fecha de inicio del Servicio de GPS", "warning");
					return false;
				}
				if (item.VehGpsEnd == "") {
					this.$fun.alert("Seleccionar fecha fín del Servicio de GPS", "warning");
					return false;
				}
				if (!this.$fun.isValidRangeDate(item.VehGpsInit, item.VehGpsEnd)) {
					this.$fun.alert("Verifique rango de fecha del Servicio de GPS", "warning");
					return false;
				}
			}





			return true;
		},
		saveVeh() {
			const raw = Array.isArray(this.item) ? (this.item[0] || {}) : (this.item || {});
			raw.TypeArea = this.typeArea;

			if (this.validatedVeh(raw)) {
				this.$fun.alert("¿Seguro de Guardar?", "question").then((val) => {
					if (val.value) {
						const toDate = (v) => {
							if (!v || v === "" || typeof v === "undefined") return null;
							const m = this.moment(v, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY", this.moment.ISO_8601]);
							return m.isValid() ? m.format("YYYY-MM-DD") : null;
						};

						// Extraer datos de transportista si VehRuc es un objeto por el return-object del selector
						const carrier = (typeof raw.VehRuc === 'object' && raw.VehRuc !== null) ? raw.VehRuc : null;
						const spcId = carrier ? carrier.SpcID : raw.SpcID;
						const vehRucStr = carrier ? carrier.SpcDocument : (typeof raw.VehRuc === 'string' ? raw.VehRuc : null);
						const vehBusinessNameStr = carrier ? carrier.SpcCompanyName : raw.VehBusinessName;

						// Objeto adaptado exactamente a la entidad MngVehicle que espera el backend
						const payload = {
							VehID: Number(raw.VehID) || -1,
							AreID: Number(this.areID || raw.AreID) || 0,
							TypeArea: raw.TypeArea ? Number(raw.TypeArea) : (this.typeArea ? Number(this.typeArea) : null),
							TypeVehicle: Number(raw.TypeVehicle) || 1,
							TypeVehicleBrand: raw.TypeVehicleBrand ? Number(raw.TypeVehicleBrand) : null,
							VehPlate: raw.VehPlate ? String(raw.VehPlate).trim() : "",
							VehMotor: raw.VehMotor ? String(raw.VehMotor).trim() : "",
							VehSerie: raw.VehSerie ? String(raw.VehSerie).trim() : "",
							TypeBrand: Number(raw.TypeBrand) || 0,
							TypeModel: Number(raw.TypeModel) || 0,
							TypeColor: Number(raw.TypeColor) || 0,
							VehFabricationYear: Number(raw.VehFabricationYear) || 0,
							VehSeatCapacity: Number(raw.VehSeatCapacity) || 0,
							TypeEnsuredr: raw.TypeEnsuredr ? Number(raw.TypeEnsuredr) : null,
							VehEnsuredInit: toDate(raw.VehEnsuredInit),
							VehEnsuredEnd: toDate(raw.VehEnsuredEnd),
							VehEnsuredCost: (raw.VehEnsuredCost !== "" && raw.VehEnsuredCost != null) ? Number(raw.VehEnsuredCost) : null,
							VehPolicy: raw.VehPolicy || null,
							VehPolicyInit: toDate(raw.VehPolicyInit),
							VehPolicyEnd: toDate(raw.VehPolicyEnd),
							VehTechnicalReviewInit: toDate(raw.VehTechnicalReviewInit),
							VehTechnicalReviewEnd: toDate(raw.VehTechnicalReviewEnd),
							TypeGpsProvider: raw.TypeGpsProvider ? Number(raw.TypeGpsProvider) : null,
							VehGpsNumber: raw.VehGpsNumber || null,
							VehGpsInit: toDate(raw.VehGpsInit),
							VehGpsEnd: toDate(raw.VehGpsEnd),
							VehMileage: Number(raw.VehMileage) || 0,
							VehStatus: Number(raw.VehStatus) || 1,
							ApprobalStatus: raw.ApprobalStatus ? Number(raw.ApprobalStatus) : null,
							VehBusinessName: vehBusinessNameStr ? String(vehBusinessNameStr).trim() : null,
							VehRuc: vehRucStr ? String(vehRucStr).trim() : null,
							SpcID: Number(spcId) || 0,
							SecStatus: Number(raw.SecStatus) || 1,
							RegistrationConstancy: raw.RegistrationConstancy || null,
						};

						console.log("save payload enviado a C#:", payload);
						_sVehicle.save(payload, this.$fun.getUserID()).then(async (r) => {
							const vehId = (r.data && r.data.VehID) || payload.VehID || this.value;
							this.$fun.alert("Guardado Correctamente", "success");
							this.$emit("save", r.data);
							this.close();
						});
					}
				});
			}
		},
		validateInput(value) {
			if (value.includes(' ')) {
				this.$nextTick(() => {
					this.item.VehPlate = value.replace(/\s/g, '');
				});
			}
		},
		changecarrier: function (value) {
			// console.log({ value });
			this.item.SpcID = value ? value.SpcID : null;
			this.item.VehRuc = value ? value.SpcDocument : '';
			this.item.VehBusinessName = value ? value.SpcCompanyName : '';
		},
		doubleClick(event, row) {
			const { item } = row
			const typeEnsure = this.setValueAseguradora(item.CodigoSBSAseguradora);
			this.item.TypeEnsuredr = typeEnsure
			this.item.VehEnsuredInit = item.FechaInicio
			this.item.VehEnsuredEnd = item.FechaFin
			this.item.VehPolicy = item.NumeroPoliza
			// console.log(item)
		},
		setValueAseguradora(CodigoSBSAseguradora) {
			let value = ""
			switch (CodigoSBSAseguradora) {
				case "050": value = 1 //Rimac Seguros
					break;
				case "074": value = 2 //Mapfre Perú
					break;
				case "041": value = 3 //La Positiva
					break;
				case "202": value = 4 //Interseguro
					break;
				// case "": value = 5 //Protecta Seguro
				//   break;
				case "044": value = 6 //Pacifico Seguros
					break;
				default: value = ""
					break;
			}
			return value;
		},
		loadcarriers() {
			_SpcCarrierService.list({ Search: '' }, this.$fun.getUserID()).then(result => {
				if (result.status == 200) {
					this.itemsCarriers = result.data.map(x => ({
						...x, SpcFullCompanyName: `${x.SpcDocument} - ${x.SpcCompanyName}`
					}))
				}
			})
		},
		verifySoat() {
			if (this.item.VehPlate == undefined || this.item.VehPlate.length <= 0) {
				this.$fun.alert("Ingrese Placa de vehículo", "warning");
				return false;
			}

			_sVehicle.verifyVehSoat({ plate: this.item.VehPlate }, this.$fun.getUserID()).then(result => {
				// console.log(result)
				if (result.status == 200) {
					this.isSearchedSoat = true;
					this.itemsSoat = result.data;
					if (this.itemsSoat.length > 0) {
						this.$fun.alert("Registros de SOAT encontrados", "success");
					} else {
						this.$fun.alert("No se encontraron registros de SOAT", "info");
					}
				} else {
					this.itemsSoat = [];
					this.$fun.alert("No se encontraron registros de SOAT", "info");
				}
			})
		},
	},
};
</script>

<style scoped></style>
